import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Employee } from "../../components/Employees/types/employees";

/** Alias kept for code merged from the Product/Order MFEs, which used a loose UserDetails type. */
export type UserDetails = Employee;

export interface UserState {
  userDetails?: Employee;
  /** True when the initial profile fetch failed; allows PortalHomePage to show error + retry. */
  profileLoadError?: boolean;
}

export const initialUserState: UserState = {};

export const userSlice = createSlice({
  name: "userSlice",
  initialState: initialUserState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<Employee>) => {
      state.userDetails = action.payload;
    },
    resetUserDetails: (state) => {
      state.userDetails = initialUserState.userDetails;
    },
    setProfileLoadError: (state, action: PayloadAction<boolean>) => {
      state.profileLoadError = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setUserDetails, resetUserDetails, setProfileLoadError } =
  userSlice.actions;

export default userSlice.reducer;
